var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcToolCompartir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17,
    viewBox: "0 0 17.001 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1353",
    "data-name": "Grupo 1353",
    transform: "translate(3.633 -0.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1121",
    "data-name": "Grupo 1121",
    transform: "translate(-3.593 0.407)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1120",
    "data-name": "Grupo 1120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1119",
    "data-name": "Grupo 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1118",
    "data-name": "Grupo 1118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1117",
    "data-name": "Grupo 1117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_244",
    "data-name": "Rect\\xE1ngulo 244",
    width: 17,
    height: 17,
    transform: "translate(-0.04 -0.04)",
    fill: "#684e07"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1354",
    "data-name": "Grupo 1354",
    transform: "translate(-1.943 -1.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_623",
    "data-name": "Trazado 623",
    d: "M2.062,7.189a2.54,2.54,0,0,1,.385-.867A1.923,1.923,0,0,1,4,5.535c.814-.012,1.626,0,2.44,0a.544.544,0,0,1,.58.532.531.531,0,0,1-.567.541c-.775.006-1.549,0-2.324,0a1.44,1.44,0,0,0-.361.036.873.873,0,0,0-.645.864c-.006.442,0,.885,0,1.327v8.781a.916.916,0,0,0,1.034,1.027H16.974A.913.913,0,0,0,18,17.625q0-2.939,0-5.877a.53.53,0,0,1,1.037-.173.573.573,0,0,1,.024.179c0,2.025,0,4.05,0,6.075A1.937,1.937,0,0,1,17.174,19.7q-6.606,0-13.213,0A1.95,1.95,0,0,1,2.1,18.152a1.094,1.094,0,0,0-.036-.107Z",
    transform: "translate(-3.751 -0.396)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_624",
    "data-name": "Trazado 624",
    d: "M15.051,2.063a4.954,4.954,0,0,1,.4.338q2.2,2.273,4.383,4.558a.868.868,0,0,1,.192.4.494.494,0,0,1-.191.437q-1.572,1.631-3.143,3.264c-.457.474-.912.95-1.371,1.423a.532.532,0,0,1-.688.131.546.546,0,0,1-.275-.513q0-1.021,0-2.042v-.2c-.419,0-.828-.024-1.233,0a5.738,5.738,0,0,0-3.108,1.152,5.842,5.842,0,0,0-1.692,2.014.54.54,0,0,1-.771.28.458.458,0,0,1-.267-.41c.014-.679,0-1.362.069-2.037A6.359,6.359,0,0,1,8.7,7.608a6.834,6.834,0,0,1,3.77-2.5,7.147,7.147,0,0,1,1.687-.221h.2V4.462c0-.57.011-1.14,0-1.709a.648.648,0,0,1,.4-.69Zm.382,8.712.042.01,3.283-3.41L15.433,3.922v.223c0,.415,0,.831,0,1.245a.535.535,0,0,1-.571.573c-.116,0-.232,0-.349,0a6.075,6.075,0,0,0-1.694.164,5.8,5.8,0,0,0-4.331,4.407c-.04.153-.055.312-.081.468a4.758,4.758,0,0,0,.459-.41,6.586,6.586,0,0,1,3.871-1.748c.708-.068,1.424-.049,2.138-.054a.526.526,0,0,1,.559.581c0,.409,0,.818,0,1.228Z",
    transform: "translate(-4.721 0.248)",
    fill: "#684e07"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcToolCompartir);
export default __webpack_public_path__ + "static/media/ic_tool_compartir.ed80bef355f05b22a4d092e3856fe9d3.svg";
export { ForwardRef as ReactComponent };